import React from 'react'
import './catalogo.css'
import BLINDADAS from '../../assets/chocotorta.png'
import SUNCHOS from '../../assets/pastelitos.png'
import PLANAS from '../../assets/ricota.png'
import PIROMETROS from '../../assets/roscas.png'
import TERMOCUPLAS from '../../assets/torta1.png'
import CARTUCHOS from '../../assets/torta2.png'


const data = [
    {
        id:1,
        image: BLINDADAS,
        title: 'Chocotorta'      
    },
    {
        id:2,
        image: PLANAS,
        title: 'Torta de Ricota'       
    },
    {
        id:3,
        image: SUNCHOS,
        title: 'Pastelitos'        
    },
    {
        id:4,
        image: PIROMETROS,
        title: 'Roscas'    
    },
    {
        id:5,
        image: TERMOCUPLAS,
        title: 'Torta'      
    },
    {
        id:6,
        image: CARTUCHOS,
        title: 'Torta'      
    }
]

const Catalogo = () => {
    return (
      <section id='catalogo'>
          <h5>PANIFICADOS-PASTELERIA-PERNILES</h5>
          <h2>CATALOGO</h2>

          <div className="container catalogo__container">
            {
                data.map(({id, image, title, detail}) =>{
                    return(
                        <article key={id} className='catalogo__item'>
                            <div className="catalogo__item-image">
                                <img src={image} alt={title} />
                            </div>
                            <h3>{title}</h3>
                            <p>{detail}</p>
                            <div className="catalogo__item-cta">
                                <a href="#contact" className='btn btn-primary' >CONTACTO</a>
                                <a href="https://api.whatsapp.com/send?phone=5491144296226&text=Hola!%20Necesito%20informaci%C3%B3n%20sobre%20un%20producto%20de%20la%20web%20" className='btn btn-succes'  target="_blank" rel="noreferrer">WHATSAPP</a>
                            </div>
                        </article>
                    )
                })
            }

          </div>

      </section>
    )
  }
  
  export default Catalogo